import api, { tokenManager } from '@/lib/api';
import { downloadBlob } from '@/lib/download';

export interface MarketingConsentRow {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  marketingConsentAt: string | null;
  privacyVersion: string | null;
  termsVersion: string | null;
  createdAt: string;
}

export interface MarketingConsentPage {
  items: MarketingConsentRow[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export interface MarketingConsentFilters {
  q?: string;
  role?: string;
}

export async function getMarketingConsents(
  page: number,
  filters: MarketingConsentFilters = {}
): Promise<MarketingConsentPage> {
  const res = await api.get('/marketing-consents', {
    params: {
      page,
      limit: 25,
      q: filters.q || undefined,
      role: filters.role || undefined,
    },
  });
  return res.data.data as MarketingConsentPage;
}

/**
 * Scarica il CSV dei consensi marketing applicando i filtri correnti.
 * Usa fetch diretto (non l'istanza axios) per gestire il blob e l'header auth.
 */
export async function downloadMarketingConsentsCsv(
  filters: MarketingConsentFilters = {}
): Promise<void> {
  const base = (import.meta.env.VITE_API_URL as string | undefined) ?? '/api';
  const params = new URLSearchParams();
  if (filters.q) params.set('q', filters.q);
  if (filters.role) params.set('role', filters.role);
  const qs = params.toString();
  const url = `${base}/marketing-consents/export${qs ? `?${qs}` : ''}`;

  const token = tokenManager.getAccessToken();
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    throw new Error(`Export consensi marketing fallito (HTTP ${res.status})`);
  }

  const stamp = new Date().toISOString().slice(0, 10);
  downloadBlob(await res.blob(), `consensi-marketing-${stamp}.csv`);
}
